const COUNTRIES = [
    {
        countryCode: 'AD',
        countryName: 'Andorra',
        continent: 'EU',
    },
    {
        countryCode: 'AE',
        countryName: 'United Arab Emirates',
        continent: 'AS',
    },
    {
        countryCode: 'AF',
        countryName: 'Afghanistan',
        continent: 'AS',
    },
    {
        countryCode: 'AG',
        countryName: 'Antigua and Barbuda',
        continent: 'CA',
    },
    {
        countryCode: 'AI',
        countryName: 'Anguilla',
        continent: 'CA',
    },
    {
        countryCode: 'AL',
        countryName: 'Albania',
        continent: 'EU',
    },
    {
        countryCode: 'AM',
        countryName: 'Armenia',
        continent: 'AS',
    },
    {
        countryCode: 'AO',
        countryName: 'Angola',
        continent: 'AF',
    },
    {
        countryCode: 'AQ',
        countryName: 'Antarctica',
        continent: 'AN',
    },
    {
        countryCode: 'AR',
        countryName: 'Argentina',
        continent: 'SA',
    },
    {
        countryCode: 'AS',
        countryName: 'American Samoa',
        continent: 'OC',
    },
    {
        countryCode: 'AT',
        countryName: 'Austria',
        continent: 'EU',
    },
    {
        countryCode: 'AU',
        countryName: 'Australia',
        continent: 'OC',
    },
    {
        countryCode: 'AW',
        countryName: 'Aruba',
        continent: 'CA',
    },
    {
        countryCode: 'AX',
        countryName: 'Åland',
        continent: 'EU',
    },
    {
        countryCode: 'AZ',
        countryName: 'Azerbaijan',
        continent: 'AS',
    },
    {
        countryCode: 'BA',
        countryName: 'Bosnia and Herzegovina',
        continent: 'EU',
    },
    {
        countryCode: 'BB',
        countryName: 'Barbados',
        continent: 'CA',
    },
    {
        countryCode: 'BD',
        countryName: 'Bangladesh',
        continent: 'AS',
    },
    {
        countryCode: 'BE',
        countryName: 'Belgium',
        continent: 'EU',
    },
    {
        countryCode: 'BF',
        countryName: 'Burkina Faso',
        continent: 'AF',
    },
    {
        countryCode: 'BG',
        countryName: 'Bulgaria',
        continent: 'EU',
    },
    {
        countryCode: 'BH',
        countryName: 'Bahrain',
        continent: 'AS',
    },
    {
        countryCode: 'BI',
        countryName: 'Burundi',
        continent: 'AF',
    },
    {
        countryCode: 'BJ',
        countryName: 'Benin',
        continent: 'AF',
    },
    {
        countryCode: 'BL',
        countryName: 'Saint Barthélemy',
        continent: 'CA',
    },
    {
        countryCode: 'BM',
        countryName: 'Bermuda',
        continent: 'CA',
    },
    {
        countryCode: 'BN',
        countryName: 'Brunei',
        continent: 'AS',
    },
    {
        countryCode: 'BO',
        countryName: 'Bolivia',
        continent: 'SA',
    },
    {
        countryCode: 'BQ',
        countryName: 'Bonaire',
        continent: 'CA',
    },
    {
        countryCode: 'BR',
        countryName: 'Brazil',
        continent: 'SA',
    },
    {
        countryCode: 'BS',
        countryName: 'Bahamas',
        continent: 'CA',
    },
    {
        countryCode: 'BT',
        countryName: 'Bhutan',
        continent: 'AS',
    },
    {
        countryCode: 'BV',
        countryName: 'Bouvet Island',
        continent: 'AN',
    },
    {
        countryCode: 'BW',
        countryName: 'Botswana',
        continent: 'AF',
    },
    {
        countryCode: 'BY',
        countryName: 'Belarus',
        continent: 'EU',
    },
    {
        countryCode: 'BZ',
        countryName: 'Belize',
        continent: 'CA',
    },
    {
        countryCode: 'CA',
        countryName: 'Canada',
        continent: 'NA',
    },
    {
        countryCode: 'CC',
        countryName: 'Cocos [Keeling] Islands',
        continent: 'AS',
    },
    {
        countryCode: 'CD',
        countryName: 'Democratic Republic of the Congo',
        continent: 'AF',
    },
    {
        countryCode: 'CF',
        countryName: 'Central African Republic',
        continent: 'AF',
    },
    {
        countryCode: 'CG',
        countryName: 'Republic of the Congo',
        continent: 'AF',
    },
    {
        countryCode: 'CH',
        countryName: 'Switzerland',
        continent: 'EU',
    },
    {
        countryCode: 'CI',
        countryName: 'Ivory Coast',
        continent: 'AF',
    },
    {
        countryCode: 'CK',
        countryName: 'Cook Islands',
        continent: 'OC',
    },
    {
        countryCode: 'CL',
        countryName: 'Chile',
        continent: 'SA',
    },
    {
        countryCode: 'CM',
        countryName: 'Cameroon',
        continent: 'AF',
    },
    {
        countryCode: 'CN',
        countryName: 'China',
        continent: 'AS',
    },
    {
        countryCode: 'CO',
        countryName: 'Colombia',
        continent: 'SA',
    },
    {
        countryCode: 'CR',
        countryName: 'Costa Rica',
        continent: 'CA',
    },
    {
        countryCode: 'CU',
        countryName: 'Cuba',
        continent: 'CA',
    },
    {
        countryCode: 'CV',
        countryName: 'Cape Verde',
        continent: 'AF',
    },
    {
        countryCode: 'CW',
        countryName: 'Curacao',
        continent: 'CA',
    },
    {
        countryCode: 'CX',
        countryName: 'Christmas Island',
        continent: 'AS',
    },
    {
        countryCode: 'CY',
        countryName: 'Cyprus',
        continent: 'EU',
    },
    {
        countryCode: 'CZ',
        countryName: 'Czechia',
        continent: 'EU',
    },
    {
        countryCode: 'DE',
        countryName: 'Germany',
        continent: 'EU',
    },
    {
        countryCode: 'DJ',
        countryName: 'Djibouti',
        continent: 'AF',
    },
    {
        countryCode: 'DK',
        countryName: 'Denmark',
        continent: 'EU',
    },
    {
        countryCode: 'DM',
        countryName: 'Dominica',
        continent: 'CA',
    },
    {
        countryCode: 'DO',
        countryName: 'Dominican Republic',
        continent: 'CA',
    },
    {
        countryCode: 'DZ',
        countryName: 'Algeria',
        continent: 'AF',
    },
    {
        countryCode: 'EC',
        countryName: 'Ecuador',
        continent: 'SA',
    },
    {
        countryCode: 'EE',
        countryName: 'Estonia',
        continent: 'EU',
    },
    {
        countryCode: 'EG',
        countryName: 'Egypt',
        continent: 'AF',
    },
    {
        countryCode: 'EH',
        countryName: 'Western Sahara',
        continent: 'AF',
    },
    {
        countryCode: 'ER',
        countryName: 'Eritrea',
        continent: 'AF',
    },
    {
        countryCode: 'ES',
        countryName: 'Spain',
        continent: 'EU',
    },
    {
        countryCode: 'ET',
        countryName: 'Ethiopia',
        continent: 'AF',
    },
    {
        countryCode: 'FI',
        countryName: 'Finland',
        continent: 'EU',
    },
    {
        countryCode: 'FJ',
        countryName: 'Fiji',
        continent: 'OC',
    },
    {
        countryCode: 'FK',
        countryName: 'Falkland Islands',
        continent: 'SA',
    },
    {
        countryCode: 'FM',
        countryName: 'Micronesia',
        continent: 'OC',
    },
    {
        countryCode: 'FO',
        countryName: 'Faroe Islands',
        continent: 'EU',
    },
    {
        countryCode: 'FR',
        countryName: 'France',
        continent: 'EU',
    },
    {
        countryCode: 'GA',
        countryName: 'Gabon',
        continent: 'AF',
    },
    {
        countryCode: 'GB',
        countryName: 'United Kingdom',
        continent: 'EU',
    },
    {
        countryCode: 'GD',
        countryName: 'Grenada',
        continent: 'CA',
    },
    {
        countryCode: 'GE',
        countryName: 'Georgia',
        continent: 'AS',
    },
    {
        countryCode: 'GF',
        countryName: 'French Guiana',
        continent: 'SA',
    },
    {
        countryCode: 'GG',
        countryName: 'Guernsey',
        continent: 'EU',
    },
    {
        countryCode: 'GH',
        countryName: 'Ghana',
        continent: 'AF',
    },
    {
        countryCode: 'GI',
        countryName: 'Gibraltar',
        continent: 'EU',
    },
    {
        countryCode: 'GL',
        countryName: 'Greenland',
        continent: 'CA',
    },
    {
        countryCode: 'GM',
        countryName: 'Gambia',
        continent: 'AF',
    },
    {
        countryCode: 'GN',
        countryName: 'Guinea',
        continent: 'AF',
    },
    {
        countryCode: 'GP',
        countryName: 'Guadeloupe',
        continent: 'CA',
    },
    {
        countryCode: 'GQ',
        countryName: 'Equatorial Guinea',
        continent: 'AF',
    },
    {
        countryCode: 'GR',
        countryName: 'Greece',
        continent: 'EU',
    },
    {
        countryCode: 'GS',
        countryName: 'South Georgia and the South Sandwich Islands',
        continent: 'AN',
    },
    {
        countryCode: 'GT',
        countryName: 'Guatemala',
        continent: 'CA',
    },
    {
        countryCode: 'GU',
        countryName: 'Guam',
        continent: 'OC',
    },
    {
        countryCode: 'GW',
        countryName: 'Guinea-Bissau',
        continent: 'AF',
    },
    {
        countryCode: 'GY',
        countryName: 'Guyana',
        continent: 'SA',
    },
    {
        countryCode: 'HK',
        countryName: 'Hong Kong',
        continent: 'AS',
    },
    {
        countryCode: 'HM',
        countryName: 'Heard Island and McDonald Islands',
        continent: 'AN',
    },
    {
        countryCode: 'HN',
        countryName: 'Honduras',
        continent: 'CA',
    },
    {
        countryCode: 'HR',
        countryName: 'Croatia',
        continent: 'EU',
    },
    {
        countryCode: 'HT',
        countryName: 'Haiti',
        continent: 'CA',
    },
    {
        countryCode: 'HU',
        countryName: 'Hungary',
        continent: 'EU',
    },
    {
        countryCode: 'ID',
        countryName: 'Indonesia',
        continent: 'AS',
    },
    {
        countryCode: 'IE',
        countryName: 'Ireland',
        continent: 'EU',
    },
    {
        countryCode: 'IL',
        countryName: 'Israel',
        continent: 'AS',
    },
    {
        countryCode: 'IM',
        countryName: 'Isle of Man',
        continent: 'EU',
    },
    {
        countryCode: 'IN',
        countryName: 'India',
        continent: 'AS',
    },
    {
        countryCode: 'IO',
        countryName: 'British Indian Ocean Territory',
        continent: 'AS',
    },
    {
        countryCode: 'IQ',
        countryName: 'Iraq',
        continent: 'AS',
    },
    {
        countryCode: 'IR',
        countryName: 'Iran',
        continent: 'AS',
    },
    {
        countryCode: 'IS',
        countryName: 'Iceland',
        continent: 'EU',
    },
    {
        countryCode: 'IT',
        countryName: 'Italy',
        continent: 'EU',
    },
    {
        countryCode: 'JE',
        countryName: 'Jersey',
        continent: 'EU',
    },
    {
        countryCode: 'JM',
        countryName: 'Jamaica',
        continent: 'CA',
    },
    {
        countryCode: 'JO',
        countryName: 'Jordan',
        continent: 'AS',
    },
    {
        countryCode: 'JP',
        countryName: 'Japan',
        continent: 'AS',
    },
    {
        countryCode: 'KE',
        countryName: 'Kenya',
        continent: 'AF',
    },
    {
        countryCode: 'KG',
        countryName: 'Kyrgyzstan',
        continent: 'AS',
    },
    {
        countryCode: 'KH',
        countryName: 'Cambodia',
        continent: 'AS',
    },
    {
        countryCode: 'KI',
        countryName: 'Kiribati',
        continent: 'OC',
    },
    {
        countryCode: 'KM',
        countryName: 'Comoros',
        continent: 'AF',
    },
    {
        countryCode: 'KN',
        countryName: 'Saint Kitts and Nevis',
        continent: 'CA',
    },
    {
        countryCode: 'KP',
        countryName: 'North Korea',
        continent: 'AS',
    },
    {
        countryCode: 'KR',
        countryName: 'South Korea',
        continent: 'AS',
    },
    {
        countryCode: 'KW',
        countryName: 'Kuwait',
        continent: 'AS',
    },
    {
        countryCode: 'KY',
        countryName: 'Cayman Islands',
        continent: 'CA',
    },
    {
        countryCode: 'KZ',
        countryName: 'Kazakhstan',
        continent: 'AS',
    },
    {
        countryCode: 'LA',
        countryName: 'Laos',
        continent: 'AS',
    },
    {
        countryCode: 'LB',
        countryName: 'Lebanon',
        continent: 'AS',
    },
    {
        countryCode: 'LC',
        countryName: 'Saint Lucia',
        continent: 'CA',
    },
    {
        countryCode: 'LI',
        countryName: 'Liechtenstein',
        continent: 'EU',
    },
    {
        countryCode: 'LK',
        countryName: 'Sri Lanka',
        continent: 'AS',
    },
    {
        countryCode: 'LR',
        countryName: 'Liberia',
        continent: 'AF',
    },
    {
        countryCode: 'LS',
        countryName: 'Lesotho',
        continent: 'AF',
    },
    {
        countryCode: 'LT',
        countryName: 'Lithuania',
        continent: 'EU',
    },
    {
        countryCode: 'LU',
        countryName: 'Luxembourg',
        continent: 'EU',
    },
    {
        countryCode: 'LV',
        countryName: 'Latvia',
        continent: 'EU',
    },
    {
        countryCode: 'LY',
        countryName: 'Libya',
        continent: 'AF',
    },
    {
        countryCode: 'MA',
        countryName: 'Morocco',
        continent: 'AF',
    },
    {
        countryCode: 'MC',
        countryName: 'Monaco',
        continent: 'EU',
    },
    {
        countryCode: 'MD',
        countryName: 'Moldova',
        continent: 'EU',
    },
    {
        countryCode: 'ME',
        countryName: 'Montenegro',
        continent: 'EU',
    },
    {
        countryCode: 'MF',
        countryName: 'Saint Martin',
        continent: 'CA',
    },
    {
        countryCode: 'MG',
        countryName: 'Madagascar',
        continent: 'AF',
    },
    {
        countryCode: 'MH',
        countryName: 'Marshall Islands',
        continent: 'OC',
    },
    {
        countryCode: 'MK',
        countryName: 'Macedonia',
        continent: 'EU',
    },
    {
        countryCode: 'ML',
        countryName: 'Mali',
        continent: 'AF',
    },
    {
        countryCode: 'MM',
        countryName: 'Myanmar [Burma]',
        continent: 'AS',
    },
    {
        countryCode: 'MN',
        countryName: 'Mongolia',
        continent: 'AS',
    },
    {
        countryCode: 'MO',
        countryName: 'Macao',
        continent: 'AS',
    },
    {
        countryCode: 'MP',
        countryName: 'Northern Mariana Islands',
        continent: 'OC',
    },
    {
        countryCode: 'MQ',
        countryName: 'Martinique',
        continent: 'CA',
    },
    {
        countryCode: 'MR',
        countryName: 'Mauritania',
        continent: 'AF',
    },
    {
        countryCode: 'MS',
        countryName: 'Montserrat',
        continent: 'CA',
    },
    {
        countryCode: 'MT',
        countryName: 'Malta',
        continent: 'EU',
    },
    {
        countryCode: 'MU',
        countryName: 'Mauritius',
        continent: 'AF',
    },
    {
        countryCode: 'MV',
        countryName: 'Maldives',
        continent: 'AS',
    },
    {
        countryCode: 'MW',
        countryName: 'Malawi',
        continent: 'AF',
    },
    {
        countryCode: 'MX',
        countryName: 'Mexico',
        continent: 'NA',
    },
    {
        countryCode: 'MY',
        countryName: 'Malaysia',
        continent: 'AS',
    },
    {
        countryCode: 'MZ',
        countryName: 'Mozambique',
        continent: 'AF',
    },
    {
        countryCode: 'NA',
        countryName: 'Namibia',
        continent: 'AF',
    },
    {
        countryCode: 'NC',
        countryName: 'New Caledonia',
        continent: 'OC',
    },
    {
        countryCode: 'NE',
        countryName: 'Niger',
        continent: 'AF',
    },
    {
        countryCode: 'NF',
        countryName: 'Norfolk Island',
        continent: 'OC',
    },
    {
        countryCode: 'NG',
        countryName: 'Nigeria',
        continent: 'AF',
    },
    {
        countryCode: 'NI',
        countryName: 'Nicaragua',
        continent: 'CA',
    },
    {
        countryCode: 'NL',
        countryName: 'Netherlands',
        continent: 'EU',
    },
    {
        countryCode: 'NO',
        countryName: 'Norway',
        continent: 'EU',
    },
    {
        countryCode: 'NP',
        countryName: 'Nepal',
        continent: 'AS',
    },
    {
        countryCode: 'NR',
        countryName: 'Nauru',
        continent: 'OC',
    },
    {
        countryCode: 'NU',
        countryName: 'Niue',
        continent: 'OC',
    },
    {
        countryCode: 'NZ',
        countryName: 'New Zealand',
        continent: 'OC',
    },
    {
        countryCode: 'OM',
        countryName: 'Oman',
        continent: 'AS',
    },
    {
        countryCode: 'PA',
        countryName: 'Panama',
        continent: 'CA',
    },
    {
        countryCode: 'PE',
        countryName: 'Peru',
        continent: 'SA',
    },
    {
        countryCode: 'PF',
        countryName: 'French Polynesia',
        continent: 'OC',
    },
    {
        countryCode: 'PG',
        countryName: 'Papua New Guinea',
        continent: 'OC',
    },
    {
        countryCode: 'PH',
        countryName: 'Philippines',
        continent: 'AS',
    },
    {
        countryCode: 'PK',
        countryName: 'Pakistan',
        continent: 'AS',
    },
    {
        countryCode: 'PL',
        countryName: 'Poland',
        continent: 'EU',
    },
    {
        countryCode: 'PM',
        countryName: 'Saint Pierre and Miquelon',
        continent: 'CA',
    },
    {
        countryCode: 'PN',
        countryName: 'Pitcairn Islands',
        continent: 'OC',
    },
    {
        countryCode: 'PR',
        countryName: 'Puerto Rico',
        continent: 'CA',
    },
    {
        countryCode: 'PS',
        countryName: 'Palestine',
        continent: 'AS',
    },
    {
        countryCode: 'PT',
        countryName: 'Portugal',
        continent: 'EU',
    },
    {
        countryCode: 'PW',
        countryName: 'Palau',
        continent: 'OC',
    },
    {
        countryCode: 'PY',
        countryName: 'Paraguay',
        continent: 'SA',
    },
    {
        countryCode: 'QA',
        countryName: 'Qatar',
        continent: 'AS',
    },
    {
        countryCode: 'RE',
        countryName: 'Réunion',
        continent: 'AF',
    },
    {
        countryCode: 'RO',
        countryName: 'Romania',
        continent: 'EU',
    },
    {
        countryCode: 'RS',
        countryName: 'Serbia',
        continent: 'EU',
    },
    {
        countryCode: 'RU',
        countryName: 'Russia',
        continent: 'EU',
    },
    {
        countryCode: 'RW',
        countryName: 'Rwanda',
        continent: 'AF',
    },
    {
        countryCode: 'SA',
        countryName: 'Saudi Arabia',
        continent: 'AS',
    },
    {
        countryCode: 'SB',
        countryName: 'Solomon Islands',
        continent: 'OC',
    },
    {
        countryCode: 'SC',
        countryName: 'Seychelles',
        continent: 'AF',
    },
    {
        countryCode: 'SD',
        countryName: 'Sudan',
        continent: 'AF',
    },
    {
        countryCode: 'SE',
        countryName: 'Sweden',
        continent: 'EU',
    },
    {
        countryCode: 'SG',
        countryName: 'Singapore',
        continent: 'AS',
    },
    {
        countryCode: 'SH',
        countryName: 'Saint Helena',
        continent: 'AF',
    },
    {
        countryCode: 'SI',
        countryName: 'Slovenia',
        continent: 'EU',
    },
    {
        countryCode: 'SJ',
        countryName: 'Svalbard and Jan Mayen',
        continent: 'EU',
    },
    {
        countryCode: 'SK',
        countryName: 'Slovakia',
        continent: 'EU',
    },
    {
        countryCode: 'SL',
        countryName: 'Sierra Leone',
        continent: 'AF',
    },
    {
        countryCode: 'SM',
        countryName: 'San Marino',
        continent: 'EU',
    },
    {
        countryCode: 'SN',
        countryName: 'Senegal',
        continent: 'AF',
    },
    {
        countryCode: 'SO',
        countryName: 'Somalia',
        continent: 'AF',
    },
    {
        countryCode: 'SR',
        countryName: 'Suriname',
        continent: 'SA',
    },
    {
        countryCode: 'SS',
        countryName: 'South Sudan',
        continent: 'AF',
    },
    {
        countryCode: 'ST',
        countryName: 'São Tomé and Príncipe',
        continent: 'AF',
    },
    {
        countryCode: 'SV',
        countryName: 'El Salvador',
        continent: 'CA',
    },
    {
        countryCode: 'SX',
        countryName: 'Sint Maarten',
        continent: 'CA',
    },
    {
        countryCode: 'SY',
        countryName: 'Syria',
        continent: 'AS',
    },
    {
        countryCode: 'SZ',
        countryName: 'Swaziland',
        continent: 'AF',
    },
    {
        countryCode: 'TC',
        countryName: 'Turks and Caicos Islands',
        continent: 'CA',
    },
    {
        countryCode: 'TD',
        countryName: 'Chad',
        continent: 'AF',
    },
    {
        countryCode: 'TF',
        countryName: 'French Southern Territories',
        continent: 'AN',
    },
    {
        countryCode: 'TG',
        countryName: 'Togo',
        continent: 'AF',
    },
    {
        countryCode: 'TH',
        countryName: 'Thailand',
        continent: 'AS',
    },
    {
        countryCode: 'TJ',
        countryName: 'Tajikistan',
        continent: 'AS',
    },
    {
        countryCode: 'TK',
        countryName: 'Tokelau',
        continent: 'OC',
    },
    {
        countryCode: 'TL',
        countryName: 'East Timor',
        continent: 'OC',
    },
    {
        countryCode: 'TM',
        countryName: 'Turkmenistan',
        continent: 'AS',
    },
    {
        countryCode: 'TN',
        countryName: 'Tunisia',
        continent: 'AF',
    },
    {
        countryCode: 'TO',
        countryName: 'Tonga',
        continent: 'OC',
    },
    {
        countryCode: 'TR',
        countryName: 'Turkey',
        continent: 'AS',
    },
    {
        countryCode: 'TT',
        countryName: 'Trinidad and Tobago',
        continent: 'CA',
    },
    {
        countryCode: 'TV',
        countryName: 'Tuvalu',
        continent: 'OC',
    },
    {
        countryCode: 'TW',
        countryName: 'Taiwan',
        continent: 'AS',
    },
    {
        countryCode: 'TZ',
        countryName: 'Tanzania',
        continent: 'AF',
    },
    {
        countryCode: 'UA',
        countryName: 'Ukraine',
        continent: 'EU',
    },
    {
        countryCode: 'UG',
        countryName: 'Uganda',
        continent: 'AF',
    },
    {
        countryCode: 'UM',
        countryName: 'U.S. Minor Outlying Islands',
        continent: 'OC',
    },
    {
        countryCode: 'US',
        countryName: 'United States',
        continent: 'NA',
    },
    {
        countryCode: 'UY',
        countryName: 'Uruguay',
        continent: 'SA',
    },
    {
        countryCode: 'UZ',
        countryName: 'Uzbekistan',
        continent: 'AS',
    },
    {
        countryCode: 'VA',
        countryName: 'Vatican City',
        continent: 'EU',
    },
    {
        countryCode: 'VC',
        countryName: 'Saint Vincent and the Grenadines',
        continent: 'CA',
    },
    {
        countryCode: 'VE',
        countryName: 'Venezuela',
        continent: 'SA',
    },
    {
        countryCode: 'VG',
        countryName: 'British Virgin Islands',
        continent: 'CA',
    },
    {
        countryCode: 'VI',
        countryName: 'U.S. Virgin Islands',
        continent: 'CA',
    },
    {
        countryCode: 'VN',
        countryName: 'Vietnam',
        continent: 'AS',
    },
    {
        countryCode: 'VU',
        countryName: 'Vanuatu',
        continent: 'OC',
    },
    {
        countryCode: 'WF',
        countryName: 'Wallis and Futuna',
        continent: 'OC',
    },
    {
        countryCode: 'WS',
        countryName: 'Samoa',
        continent: 'OC',
    },
    // {
    //     countryCode: 'XK',
    //     countryName: 'Kosovo',
    //     continent: 'EU'
    // },
    {
        countryCode: 'YE',
        countryName: 'Yemen',
        continent: 'AS',
    },
    {
        countryCode: 'YT',
        countryName: 'Mayotte',
        continent: 'AF',
    },
    {
        countryCode: 'ZA',
        countryName: 'South Africa',
        continent: 'AF',
    },
    {
        countryCode: 'ZM',
        countryName: 'Zambia',
        continent: 'AF',
    },
    {
        countryCode: 'ZW',
        countryName: 'Zimbabwe',
        continent: 'AF',
    },
];

export default COUNTRIES;

export const COUNTRIES_LIST = COUNTRIES
    .map(country => ({label: `${country.countryCode} - ${country.countryName}`, value: country.countryCode}));
